/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

export enum ActionTypes {
  SomeAction = '[App] Add some descriptive title here',
  OtherAction = '[App] Add another descriptive title here',
}

export class SomeAction implements Action {
  readonly type = ActionTypes.SomeAction;
  constructor(
    public someString: string,
    public someNumber: number,
  ) {}
}

export class OtherAction implements Action {
  readonly type = ActionTypes.OtherAction;
  constructor() {}
}

// export the combined type of all actions
export type AppActions = SomeAction | OtherAction;
